import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]

  connect() {
    console.log("Field unlock controller connected")
  }

  // Unlock field for editing
  unlock(event) {
    const button = event.currentTarget
    const fieldId = button.dataset.fieldUnlockFieldIdParam || event.params.fieldId

    if (!fieldId) {
      console.error("No field ID provided")
      return
    }

    const field = document.getElementById(fieldId)

    if (!field) {
      console.error("Field not found:", fieldId)
      return
    }

    // Remove disabled attribute
    field.removeAttribute('disabled')
    field.focus()

    // Change button to "lock" mode
    button.innerHTML = '<i class="bi bi-lock-fill"></i> Zablokuj'
    button.classList.remove('btn-outline-secondary')
    button.classList.add('btn-outline-primary')

    // Change action to lock
    button.dataset.action = 'click->field-unlock#lock'
    button.dataset.fieldUnlockFieldIdParam = fieldId

    console.log("Field unlocked:", fieldId)
  }

  // Lock field after editing
  lock(event) {
    const button = event.currentTarget
    const fieldId = button.dataset.fieldUnlockFieldIdParam || event.params.fieldId

    if (!fieldId) {
      console.error("No field ID provided")
      return
    }

    const field = document.getElementById(fieldId)

    if (!field) {
      console.error("Field not found:", fieldId)
      return
    }

    // Set disabled attribute
    field.setAttribute('disabled', 'disabled')

    // Change button back to "unlock" mode
    button.innerHTML = '<i class="bi bi-pencil"></i> Edytuj'
    button.classList.remove('btn-outline-primary')
    button.classList.add('btn-outline-secondary')

    // Change action back to unlock
    button.dataset.action = 'click->field-unlock#unlock'

    console.log("Field locked:", fieldId)
  }

  // Auto-lock field on blur (after save)
  autoLock(event) {
    const field = event.target

    // Find corresponding button
    const fieldId = field.id
    const container = field.closest('.field-group') || field.closest('.input-group')
    const button = container.querySelector(`[data-field-unlock-field-id-param="${fieldId}"]`)

    if (button && button.dataset.action === 'click->field-unlock#lock') {
      // Automatically lock the field after blur (save completed)
      setTimeout(() => {
        this.lock({ currentTarget: button, params: { fieldId: fieldId } })
      }, 2500) // Wait 2.5s to allow save indicator to show
    }
  }
}
